module.exports = __webpack_public_path__ + "img/a.2db6cb43.png";